import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};


@Injectable({
  providedIn: 'root'
})
export class CustomService {

  mainApiUrl = environment.baseApiUrl;

  constructor(private http: HttpClient) {
  }

  //get all dropdown list api
  getAllCategory() {
    return this.http.get(this.mainApiUrl + 'Discrepancy/GetDiscrepancyCategory', httpOptions);
  }

  //check field max length
  checkFieldLength() {
    return this.http.get(this.mainApiUrl + 'Discrepancy/GetDiscrepancyDataLength', httpOptions);
  }

  //get all disc details
  getAllDiscpDetails(id: any) {
    return this.http.get(this.mainApiUrl + 'Discrepancy/GetDiscrepancyDetailspage?DISC_ID=' + id, httpOptions);
  }

  //save api
  saveDiscrepancyReport(formData: any) {
    return this.http.post(this.mainApiUrl + 'Discrepancy/PostReportDiscrepancy', formData);
  }

  //save details DR
  saveDiscrepancyDetails(formData: any) {
    return this.http.post(this.mainApiUrl + 'Discrepancy/UpdateDiscrepancyDetails', formData);
  }

  //publication search get api
  getAllSearchDiscrepancy(filterValue?: any,searchKey?: any,FromDatetime?:any, ToDatetime?:any, Flag?:any) {
    if(FromDatetime){
      return this.http.get(`${this.mainApiUrl}Discrepancy/SearchAdminDiscrepancy?FromDatetime=${FromDatetime}&ToDatetime=${ToDatetime}&FilterInput=${filterValue}&Flag=${Flag}`);
    }else{
      return this.http.get(`${this.mainApiUrl}Discrepancy/SearchAdminDiscrepancy?keyval=${searchKey}&FilterInput=${filterValue}&Flag=${Flag}`);
    }
     

  }
  //DR status
  drStatusType() {
    return this.http.get(this.mainApiUrl + 'Discrepancy/GetDiscrepancyStatus', httpOptions);
  }

  //Decryption
  decryptData(payload: any){
    return this.http.post(this.mainApiUrl + 'Auth/DecryptData', payload);
  }

}
